import { useState } from 'react'
import { Link, generatePath } from 'react-router-dom'

import {
  ProductItemLineFragment,
  ProductItemProductFragment,
  ProductItemSupplierFragment,
} from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { formatProductItem } from '@/modules/requisitions/utils/formatProductItem'
import { Input as FormatProductInput } from '@/modules/requisitions/utils/formatProductItem'
import ProductModal from '@/modules/shared/components/product-modal/ProductModal'
import { useViewType } from '@/modules/shared/hooks/useViewType'
import { classNames } from '@/modules/shared/utils/classNames'

interface ProductItemProps {
  product: ProductItemProductFragment | null
  clickToOpenModal?: boolean
  supplier?: ProductItemSupplierFragment | null
  hideName?: boolean
  isLink?: boolean
  customProductLink?: string
  formatProduct?: (input: FormatProductInput) => string
  unitPrice?: number
  taxPercentage?: number
  line?: ProductItemLineFragment | null
}

export const ProductItem = ({
  product,
  clickToOpenModal,
  supplier,
  hideName,
  isLink = false,
  customProductLink,
  formatProduct,
  line,
}: ProductItemProps) => {
  const { itemDescription, brand, itemSize, itemMeasure, itemPackName, concatenatedSellUnit, itemSellQuantity } =
    product || {}
  const [showProductDetailsModal, setShowProductDetailsModal] = useState(false)
  const { isUtility } = useViewType()

  return (
    <div className="flex flex-col">
      {!hideName && !isLink && (
        <p
          className={classNames('w-fit break-words leading-5 text-primary', { 'cursor-pointer': clickToOpenModal })}
          data-testid="product-details-button"
          onClick={() => clickToOpenModal && setShowProductDetailsModal(true)}
        >
          {brand} {itemDescription}
        </p>
      )}
      {!hideName && isLink && (
        <Link
          to={
            customProductLink ||
            generatePath(`${isUtility ? '/utilities' : ''}/products/:productId/details`, {
              productId: String(product?.id),
            })
          }
          className="w-fit break-words leading-5 text-primary"
        >
          {brand} {itemDescription}
        </Link>
      )}
      <span className="text-xs text-gray-500">
        {formatProduct
          ? formatProduct({
              itemSize,
              itemMeasure,
              itemPackName,
              itemSellUnit: concatenatedSellUnit,
              itemSellQuantity,
            })
          : formatProductItem({
              itemSize,
              itemMeasure,
              itemPackName,
              itemSellUnit: concatenatedSellUnit,
              itemSellQuantity,
            })}
      </span>
      <ProductModal
        showModal={showProductDetailsModal}
        setShowModal={setShowProductDetailsModal}
        supplier={supplier}
        productId={Number(product?.id)}
        formatProduct={formatProduct}
        line={line}
      />
    </div>
  )
}
